import React from "react";
import { STATUS_LABELS } from "@/lib/constants";import {
  ClipboardList, UserCheck, Loader2, CheckCircle2, AlertTriangle, ArrowUpRight, Shuffle,
} from "lucide-react";

const ICONS = {
  submitted: ClipboardList,
  assigned: UserCheck,
  in_progress: Loader2,
  resolved: CheckCircle2,
  escalated: AlertTriangle,
  escalated_to_acp: ArrowUpRight,
  escalated_to_dcp: ArrowUpRight,
  reassigned: Shuffle,
};

const COLORS = {
  submitted: "bg-slate-100 text-slate-700 border-slate-300",
  assigned: "bg-blue-50 text-blue-700 border-blue-300",
  in_progress: "bg-amber-50 text-amber-800 border-amber-300",
  resolved: "bg-emerald-50 text-emerald-700 border-emerald-300",
  escalated: "bg-red-50 text-red-700 border-red-300",
  escalated_to_acp: "bg-red-50 text-red-700 border-red-300",
  escalated_to_dcp: "bg-red-100 text-red-800 border-red-400",
  reassigned: "bg-slate-100 text-slate-700 border-slate-300",
};

const LABELS = {
  submitted: "Submitted",
  assigned: "Assigned",
  in_progress: "In Progress",
  resolved: "Resolved",
  escalated: "Escalated",
  escalated_to_acp: "Escalated → ACP",
  escalated_to_dcp: "Escalated → DCP",
  reassigned: "Reassigned",
};

export default function ComplaintTimeline({ timeline = [] }) {
  return (
    <ol className="relative border-l border-border/60 pl-6 space-y-6" data-testid="complaint-timeline">
      {timeline.map((step, i) => {
        const Icon = ICONS[step.type] || ClipboardList;
        return (
          <li key={i} className="relative">
            <span
              className={`absolute -left-[33px] top-0 grid place-items-center w-10 h-10 rounded-full border-2 bg-white ${COLORS[step.type] || "border-slate-200"}`}
            >
              <Icon className="w-4 h-4" />
            </span>
            <div className="ml-2">
              <div className="flex items-center gap-2 flex-wrap">
                <div className="font-display font-semibold text-sm">
                  {STATUS_LABELS[step.type] || step.type}
                </div>
                <div className="text-xs text-muted-foreground">
                  {new Date(step.at).toLocaleString()}
                </div>
              </div>
              {step.note && (
                <div className="mt-1 text-sm text-slate-700">{step.note}</div>
              )}
              {step.by && (
                <div className="mt-0.5 text-xs text-muted-foreground">by {step.by}</div>
              )}
            </div>
          </li>
        );
      })}
    </ol>
  );
}
